<ng-template #genericModalTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ title }}</h4>
    </div>

    <div class="modal-body">
        <p [innerHTML]="content"></p>
    </div>

    <div class="modal-footer">
        <div class="row modal-confirm-button-row">
            <div *ngIf="showCancelButton" class="col-6">
                <button (click)="onCancel()" class="btn btn-outline-danger" type="button">
                    {{ cancelText }}
                </button>
            </div>
            <div [ngClass]="showCancelButton ? 'col-6 right-align' : 'col-12 right-align'">
                <button (click)="onConfirm()" [class]="confirmButtonClass" type="button">
                    {{ confirmText }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
